import {
	Model,
	TransactionErrorType,
	YardTrip
} from ".";

export default class YardTripError extends Model {
	get singularNoun() {
		return "trip error";
	}

	get mutations() {
		return {
			errorTypes: TransactionErrorType,
			trip: YardTrip
		};
	}

	get errorTypeNames() {
		if ( this.errorTypes ) {
			return this.errorTypes.map( type => type.name ).join( ", " );
		}
	}

	resource() {
		return "errors";
	}
}
